/**
 * Members unlock form: stores password attempt on cart attributes, then reloads.
 * Liquid compares cart.attributes.members_unlock_key to the theme setting (password never in JS).
 */

class MembersUnlockForm extends HTMLElement {
  connectedCallback() {
    this.form = this.querySelector('form');
    this.input = this.querySelector('[data-members-password]');
    this.error = this.querySelector('[data-members-error]');
    this.submitButton = this.querySelector('[type="submit"]');

    if (!this.form) return;

    this.form.addEventListener('submit', (event) => {
      event.preventDefault();
      this.unlock();
    });
  }

  setLoading(isLoading) {
    if (!this.submitButton) return;
    this.submitButton.disabled = isLoading;
    this.submitButton.setAttribute('aria-busy', isLoading ? 'true' : 'false');
  }

  showError(message) {
    if (!this.error) return;
    this.error.hidden = !message;
    this.error.textContent = message || '';
  }

  async unlock() {
    const password = (this.input?.value || '').trim();
    if (!password) {
      this.showError(this.dataset.errorRequired || 'Enter the member password.');
      this.input?.focus();
      return;
    }

    this.setLoading(true);
    this.showError('');

    try {
      const response = await fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          attributes: {
            members_unlock_key: password,
          },
        }),
      });

      if (!response.ok) {
        throw new Error('update_failed');
      }

      window.location.reload();
    } catch {
      this.setLoading(false);
      this.showError(this.dataset.errorGeneric || 'Something went wrong. Please try again.');
    }
  }
}

if (!customElements.get('members-unlock-form')) {
  customElements.define('members-unlock-form', MembersUnlockForm);
}
